import { findAndReplace } from '../../../utils/arrayModify';

export const handleUpdateStatusSurveyInAppointmentDetails = (
  state,
  { payload },
) => {
  const userAppointmentId = payload.userAppointment
    ? payload.userAppointment.id
    : null;
  const targetAppointment = state.list.find(
    ({ id }) => userAppointmentId === id,
  );

  if (!targetAppointment) return state;

  const handleReplaceItem = (allItem, item) => {
    if (item) {
      const index = allItem.findIndex(({ assignmentId }) => {
        return item.assignmentId === assignmentId;
      });
      allItem.splice(index, 1, item);
      return allItem;
    }
  };

  return {
    ...state,
    list: findAndReplace(state.list, {
      ...targetAppointment,
      surveyAssignments: handleReplaceItem(
        targetAppointment.surveyAssignments,
        payload,
      ),
    }),
  };
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/handleUpdateStateWithCompleteSurvey.js